"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditIcon = void 0;
var react_1 = __importDefault(require("react"));
var build_svg_icon_1 = require("./build-svg-icon");
exports.EditIcon = (0, build_svg_icon_1.buildSvgIcon)(function (props) {
    var _a;
    var fillColor = (_a = props.fillColor) !== null && _a !== void 0 ? _a : '#00819E';
    return (react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.1716 4.75014L9.24994 2.82843L2.37242 9.70595L2.37375 11.6263L4.29413 11.6277L11.1716 4.75014ZM0.958206 8.29173C0.582793 8.66715 0.372051 9.17642 0.37242 9.70734L0.373756 11.6277C0.374523 12.7312 1.26888 13.6256 2.37236 13.6263L4.29274 13.6277C4.82365 13.628 5.33293 13.4173 5.70834 13.0419L12.5859 6.16435C13.3669 5.3833 13.3669 4.11697 12.5859 3.33593L10.6642 1.41421C9.8831 0.633166 8.61677 0.633167 7.83572 1.41422L0.958206 8.29173Z", fill: fillColor }));
}, 'EditIcon', {
    viewBox: '0 0 14 14',
    width: '14',
    height: '14',
});
exports.default = exports.EditIcon;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRWRpdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2ljb25zL0VkaXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGdEQUEwQjtBQUMxQixtREFBZ0Q7QUFNbkMsUUFBQSxRQUFRLEdBQUcsSUFBQSw2QkFBWSxFQUNsQyxVQUFDLEtBQWU7O0lBQ2QsSUFBTSxTQUFTLEdBQUcsTUFBQyxLQUF1QixDQUFDLFNBQVMsbUNBQUksU0FBUyxDQUFDO0lBQ2xFLE9BQU8sQ0FDTCx3Q0FDRSxRQUFRLEVBQUMsU0FBUyxFQUNsQixRQUFRLEVBQUMsU0FBUyxFQUNsQixDQUFDLEVBQUMseWJBQXliLEVBQzNiLElBQUksRUFBRSxTQUFTLEdBQ2YsQ0FDSCxDQUFDO0FBQ0osQ0FBQyxFQUNELFVBQVUsRUFDVjtJQUNFLE9BQU8sRUFBRSxXQUFXO0lBQ3BCLEtBQUssRUFBRSxJQUFJO0lBQ1gsTUFBTSxFQUFFLElBQUk7Q0FDYixDQUNGLENBQUM7QUFFRixrQkFBZSxnQkFBUSxDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/icons/icons/Edit.js
// module id = 3514
// module chunks = 25